import { useEffect, useState } from "react";
import AddressModal from "./AddressModal";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

// Address interfeysi (AddressModal dagi bilan bir xil bo‘lishi shart!)
interface Address {
  region: string;
  city: string;
  street: string;
  home: string;
  etaj: string;
  latitude: number;
  longitude: number;
  delivery_type: "city" | "district" | ""; // 🆕 qo‘shildi
  display_name?: string;
}

export default function Address({ classN }: { classN?: string }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);

  // LocalStorage dan saqlangan manzilni olish
  useEffect(() => {
    const saved = localStorage.getItem("selectedAddress");
    if (saved) {
      try {
        setSelectedAddress(JSON.parse(saved));
      } catch (e) {
        console.error("❌ Not valid JSON in localStorage:", saved);
        localStorage.removeItem("selectedAddress");
      }
    }
  }, []);

  // Manzilni tanlash va saqlash
  const handleSelect = (address: Address) => {
    setSelectedAddress(address);
    localStorage.setItem("selectedAddress", JSON.stringify(address));
    setOpen(false);
  };

  return (
    <div className={`w-full flex justify-end items-center ${classN}`}>
      <div
        onClick={() => setOpen(true)}
        className="flex items-center gap-1.5 cursor-pointer select-none"
      >
        <span className="text-sm font-medium text-white truncate max-w-[200px]">
          {selectedAddress?.display_name
            ? selectedAddress.display_name
            : t("delivery_address")}
        </span>
        <ChevronDown size={16} className="text-white" />
      </div>

      {open && (
        <AddressModal
          onClose={() => setOpen(false)}
          onSelect={handleSelect}
          initialAddress={selectedAddress}
        />
      )}
    </div>
  );
}
